import { loadStripe } from '@stripe/stripe-js'
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js'
import { useCallback, useMemo } from 'react'
import { Button, Container } from 'react-bootstrap'

import { useTriggerMembershipPaymentMutation } from '../../app/stripeApiSlice'
import useAuth from '../../hooks/useAuth'
import { useFetchUserDataQuery } from '../../app/userApiSlice'
import { useNavigate } from 'react-router-dom'
import membershipPayable from '../../utils/membership/isMembershipPayable'
import Spinner from '../../components/Spinner'

const stripeKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
const stripePromise = loadStripe(stripeKey)

const StripePaymentForm = () => {
  const { uid } = useAuth()
  const navigate = useNavigate()
  const { data, isSuccess } = useFetchUserDataQuery(uid)
  const [triggerMembershipPayment, { isError }] = useTriggerMembershipPaymentMutation()

  const fetchClientSecret = useCallback(async () => {
    const { clientSecret } = await triggerMembershipPayment().unwrap()
    return clientSecret
  }, [])

  const options = useMemo(() => ({ fetchClientSecret }), [fetchClientSecret])

  if (!isSuccess) return <Spinner />

  const paymentValidUntil = data?.membership?.validUntil
  let paymentDue = membershipPayable(paymentValidUntil)

  if (paymentDue) {
    return (
      <Container className="my-4 py-5 bg-white rounded shadow" style={{ maxWidth: '600px' }}>
        {isError ? (
          <div className="text-center">
            <h5>Something went wrong</h5>
            <p>We couldn't load the payment form.</p>
            <Button className="py-2" variant="dark" onClick={() => window.location.reload()}>
              Refresh and try again
            </Button>
          </div>
        ) : (
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        )}
      </Container>
    )
  }

  const handleReturnToDashboard = async () => {
    navigate('/')
  }

  return (
    <div className="d-flex flex-column align-items-center mt-3" style={{ maxWidth: '400px' }}>
      <h1 className="m-4">Payment not due</h1>
      <p>Membership payment is not available at this time.</p>
      <Button className="mt-2 px-5 rounded-3" variant="dark" onClick={handleReturnToDashboard}>
        Go to Dashboard
      </Button>
    </div>
  )
}

export default StripePaymentForm
